import _ from 'lodash';
import angular from 'angular';
import template from './candidateApprovalView.html';
import { Inject, Async } from '../../base/decorators';
import BaseComponent from '../../base/component';

export const checkIfAllFieldsValid = function (talentData) {
    return !talentData.address &&
        !talentData.city &&
        !talentData.country &&
        !talentData.region &&
        !talentData.state;
};

export const monthDiff = (d1, d2) => {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
};

export class CandidateApprovalComponent extends BaseComponent {
    @Inject('TalentForEmployerService') talentForEmployerService;
    @Inject('$stateParams') $stateParams;
    @Inject('CandidateApprovalService') candidateApprovalService;
    @Inject('CommonCodeService') commonCodeService;
    @Inject('NotificationService') notificationService;
    @Inject('staticDataService') staticDataService;
    @Inject('LocationService') locationService;
    @Inject('$q') $q;
    @Inject('$filter') $filter;
    @Inject('utils') utils;
    @Inject('$scope') $scope;

    @Async()
    async approveProfile() {
        await this.candidateApprovalService.approveSubmission(this.$stateParams.workflowId);

        this.notificationService.success('Resume approved');
        this.canApprove = false;
    }

    sendMessageToRecruiter(textBody) {
        this.candidateApprovalService.sendMessageToRecruiter(this.$stateParams.workflowId, textBody);
    }

    copyApproveCandidate() {
        const newTalentRecord = angular.copy(this.talentForEmployer);
        if (newTalentRecord.contact.emailAddress == null ||
            newTalentRecord.contact.emailAddress.length === 0) {
            newTalentRecord.contact.emailAddress = [{
                type: 'work',
                value: ''
            }];
        } else {
            newTalentRecord.contact.emailAddress = _.map(newTalentRecord.contact.emailAddress, email => ({
                value: email,
                type: 'Work',
            }));
        }

        if (newTalentRecord.contact.mobile == null || newTalentRecord.contact.mobile.length === 0) {
            newTalentRecord.contact.mobile = [{
                type: 'work',
                value: ''
            }];
        } else {
            newTalentRecord.contact.mobile = _.map(newTalentRecord.contact.mobile, mobile => ({
                value: mobile,
                type: 'Work',
            }));
        }

        if (newTalentRecord.contact.telephone == null || newTalentRecord.contact.telephone.length === 0) {
            newTalentRecord.contact.telephone = [{
                type: 'work',
                value: ''
            }];
        } else {
            newTalentRecord.contact.telephone = _.map(newTalentRecord.contact.telephone, telephone => ({
                value: telephone,
                type: 'Work',
            }));
        }

        newTalentRecord.contact.regularWebsites = _.remove(newTalentRecord.contact.webAddress, this.utils.isWebsite);

        if (newTalentRecord.contact.regularWebsites == null ||
            newTalentRecord.contact.regularWebsites.length === 0) {
            newTalentRecord.contact.regularWebsites = [{
                type: 'website',
                value: ''
            }];
        }
        this.staticData = [{
            title: '',
            field: 'industries',
            lookupData: 'industries',
            type: 'static',
            dropDownText: 'ADD_INDUSTRY',
            subCriteria: null,
            multiple: false,
            selected: _.map(newTalentRecord.industry, value => ({
                uid: value.industryId,
                value: value.industryName,
                required: 'optional',
            })),
            showMultipleInput: true,
            setAsMandatory: false,
        },
        {
            title: '',
            field: 'skills',
            type: 'dynamic',
            dropDownText: 'ADD_SKILL',
            subCriteria: null,
            multiple: true,
            selected: _.map(newTalentRecord.skills, value => ({
                uid: value.skillId,
                value: value.skillName,
                isDerived: value.isDerived,
                required: 'optional',
            })),
            setAsMandatory: false,
        },
        {
            title: '',
            field: 'companies',
            type: 'dynamic',
            dropDownText: 'ADD_COMPANY',
            subCriteria: null,
            multiple: false,
            selected: [],
            setAsMandatory: false,
        },
        {
            title: '',
            field: 'jobTitles',
            type: 'dynamic',
            dropDownText: 'ENTER_A_JOB_TITLE',
            subCriteria: null,
            multiple: true,
            selected: [],
            setAsMandatory: false,
        },
        {
            title: '',
            field: 'schools',
            type: 'semiDynamic',
            dropDownText: 'ADD_SCHOOL',
            subCriteria: null,
            multiple: false,
            selected: [],
            setAsMandatory: false,
        },
        {
            title: '',
            field: 'educationLevel',
            type: 'dynamic',
            dropDownText: 'ADD_EDUCATION_LEVEL',
            subCriteria: null,
            multiple: false,
            selected: [],
            setAsMandatory: false,
        },
        ];

        this.monthsOfYear = [
            {
                name: 'JAN',
                id: 0,
            },
            {
                name: 'FEB',
                id: 1,
            },
            {
                name: 'MARCH',
                id: 2,
            },
            {
                name: 'APRIL',
                id: 3,
            },
            {
                name: 'MAY',
                id: 4,
            },
            {
                name: 'JUNE',
                id: 5,
            },
            {
                name: 'JULY',
                id: 6,
            },
            {
                name: 'AUG',
                id: 7,
            },
            {
                name: 'SEP',
                id: 8,
            },
            {
                name: 'OCT',
                id: 9,
            },
            {
                name: 'NOV',
                id: 10,
            },
            {
                name: 'DEC',
                id: 11,
            },
        ];

        newTalentRecord.languages = _.map(newTalentRecord.languages, (language) => {
            language.staticData = {
                title: '',
                field: 'languages',
                lookupData: 'languages',
                type: 'static',
                dropDownText: 'ENTER_A_LANGUAGE',
                subCriteria: null,
                multiple: false,
                selected: [{
                    uid: language.languageCodeId,
                    value: this.$filter('getLanguageName')(language, this.lookupLanguages),
                    required: 'optional',
                }],
                showMultipleInput: true,
                setAsMandatory: false,
            };
            return language;
        });

        return newTalentRecord;
    }

    getUrlByType(contact, type) {
        const website = _.find(contact.webAddress, { type });
        if (website) {
            return website;
        }

        const newData = {
            type,
            url: '',
        };
        contact.webAddress.push(newData);
        return newData;
    }

    updateApproveCandidate(talentData, id, editView) {
        if (!talentData.newLanguage && _.findIndex(talentData.languages, language => (language.staticData.selected.length <= 0 || language.staticData.selected[0].uid == '')) >= 0) {
            return;
        }
        if (talentData.contact) {
            _.remove(talentData.contact.webAddress, (webAddress) => {
                return webAddress.url === '' || webAddress.url == null;
            });
            _.remove(talentData.contact.regularWebsites, (webAddress) => {
                return webAddress.url === '' || webAddress.url == null;
            });
            _.remove(talentData.contact.emailAddress, (emailAddress) => {
                return emailAddress.value === '' || emailAddress.value == null;
            });
            _.remove(talentData.contact.mobile, (mobile) => {
                return mobile.value === '' || mobile.value == null;
            });
            _.remove(talentData.contact.telephone, (telephone) => {
                return telephone.value === '' || telephone.value == null;
            });
            talentData.contact.webAddress = talentData.contact.webAddress.concat(talentData.contact.regularWebsites);
            talentData.contact.emailAddress = _.map(talentData.contact.emailAddress, 'value');
            talentData.contact.mobile = _.map(talentData.contact.mobile, 'value');
            talentData.contact.fax = _.map(talentData.contact.fax, 'value');
            talentData.contact.telephone = _.map(talentData.contact.telephone, 'value');
        }
        talentData.industry = _.map(this.staticData[0].selected, value => ({
            industryId: value.uid,
            industryName: value.value,
        }));
        talentData.skills = _.map(this.staticData[1].selected, value => ({
            skillId: value.uid,
            skillName: value.value,
            isDerived: value.isDerived,
        }));
        if (talentData.newEmployment) {
            talentData.employmentHistory = talentData.employmentHistory.concat(this.talentForEmployer.employmentHistory);
        }

        if (talentData.newEducation) {
            talentData.educationHistory = talentData.educationHistory.concat(this.talentForEmployer.educationHistory);
        }

        if (talentData.newLanguage) {
            talentData.languages = talentData.languages.concat(this.talentForEmployer.languages);
        }
        if (talentData.employmentHistory) {
            talentData.employmentHistory = _.map(talentData.employmentHistory, (employment) => {
                if (employment.startMonth || employment.startYear) {
                    employment.startDate = (new Date(employment.startYear, employment.startMonth, 2)).toISOString();
                }
                if (employment.isCurrent) {
                    employment.endDate = null;
                } else if (employment.endMonth || employment.endYear) {
                    employment.endDate = (new Date(employment.endYear, employment.endMonth, 2)).toISOString();
                }
                if (employment.employmentCompanyFilter && employment.employmentCompanyFilter.selected.length > 0) {
                    employment.employerOrgId = employment.employmentCompanyFilter.selected[0].uid;
                    employment.employerOrgName = employment.employmentCompanyFilter.selected[0].value;
                } else if (employment.employmentCompanyFilter) {
                    employment.employerOrgId = null;
                    employment.employerOrgName = null;
                }
                if (employment.employmentTitlesFilter && employment.employmentTitlesFilter.selected.length > 0) {
                    employment.titles = _.map(employment.employmentTitlesFilter.selected, value => ({
                        titleId: value.uid,
                        title: value.value,
                    }));
                } else if (employment.employmentTitlesFilter) {
                    employment.titles = [];
                }
                let eDate = new Date();
                if (employment.endDate) {
                    eDate = new Date(employment.endDate);
                }
                employment.monthsOfWork = monthDiff(new Date(employment.startDate), eDate);
                return employment;
            });
            talentData.employmentHistory = _.orderBy(talentData.employmentHistory, [function (employment) {
                if (!employment.endDate) {
                    return new Date();
                }
                return new Date(employment.endDate);
            }, function (employment) {
                return new Date(employment.startDate);
            }], ['desc', 'desc']);
        }

        if (talentData.educationHistory) {
            talentData.educationHistory = _.map(talentData.educationHistory, (education) => {
                if (education.startYear) {
                    education.startDate = (new Date(education.startYear, 0, 2)).toISOString();
                }
                if (education.isCurrent) {
                    education.endDate = null;
                } else if (education.endYear) {
                    education.endDate = (new Date(education.endYear, 0, 2)).toISOString();
                }
                if (education.educationHistoryFilter && education.educationHistoryFilter.selected.length > 0) {
                    education.schoolId = education.educationHistoryFilter.selected[0].uid;
                    education.schoolName = education.educationHistoryFilter.selected[0].value;
                } else if (education.educationHistoryFilter) {
                    education.schoolId = null;
                    education.schoolName = null;
                }
                if (education.educationDegreeFilter && education.educationDegreeFilter.selected) {
                    education.degree = education.educationDegreeFilter.selected;
                } else if (education.educationDegreeFilter) {
                    education.degree = [];
                }
                let eDate = new Date();
                if (education.endDate) {
                    eDate = new Date(education.endDate);
                }
                education.monthsOfWork = monthDiff(new Date(education.startDate), eDate);
                return education;
            });
            talentData.educationHistory = _.orderBy(talentData.educationHistory, [function (education) {
                if (!education.endDate) {
                    return new Date();
                }
                return new Date(education.endDate);
            }, function (education) {
                return new Date(education.startDate);
            }], ['desc', 'desc']);
            this.cleanMyJson(talentData);
        }

        talentData.languages = _.map(talentData.languages, (language) => {
            if (language.languageFilter && language.languageFilter.selected.length > 0) {
                language.languageCodeId = language.languageFilter.selected[0].uid;
                language.languageCode = language.languageFilter.selected[0].value;
            } else if (language.staticData && language.staticData.selected.length > 0) {
                language.languageCodeId = language.staticData.selected[0].uid;
                language.languageCode = language.staticData.selected[0].value;
            } else if (language.languageFilter) {
                language.languageCodeId = null;
                language.languageCode = null;
            }
            delete language.languageFilter;
            return language;
        });

        if (editView === 'showApplicantDetailsEdit') {
            delete talentData.residency; // remove residency from the sent json
            delete talentData.location; // remove residency from the sent json
            this.serviceUpdateCandidate(id, talentData, editView);
        } else if (editView === 'showTalentResidency') {
            if (!checkIfAllFieldsValid(talentData.residency)) {
                const promises = [];
                promises.push(this.getLocationLangLat(talentData.residency));
                this.$q.all(promises)
                    .then(() => {
                        this.serviceUpdateCandidate(id, talentData, editView);
                    })
                    .catch(error => this.logger.error(error));
            } else {
                talentData.residency.geoLocation = null;
                talentData.location.geoLocation = null;
                this.serviceUpdateCandidate(id, talentData, editView);
            }
        } else {
            this.serviceUpdateCandidate(id, talentData, editView);
        }
    }

    @Async()
    async serviceUpdateCandidate(id, talentData, editView) {
        await this.talentForEmployerService.updateTalentForEmployer(id, talentData);

        if (talentData.newEmployment) {
            this.talentForEmployer.employmentHistory = talentData.employmentHistory;
            this.talentForEmployer.industry = talentData.industry;
            this.talentForEmployer.skills = talentData.skills;
        } else if (talentData.newLanguage) {
            this.talentForEmployer.languages = talentData.languages;
            this.talentForEmployer.industry = talentData.industry;
            this.talentForEmployer.skills = talentData.skills;
        } else if (talentData.newEducation) {
            this.talentForEmployer.educationHistory = talentData.educationHistory;
        } else {
            if (!talentData.location) {
                talentData.location = this.talentForEmployer.location;
            }
            if (!talentData.residency) {
                talentData.residency = this.talentForEmployer.residency;
            }
            this.talentForEmployer = talentData;
        }
        // Send residency only if we are changing the Residency
        if (editView === 'showTalentResidency') {
            this.residency = this.commonCodeService.getLocationString(this.talentForEmployer.residency);
        }
        this[editView] = false;
    }

    initAddEmployment() {
        return [{
            description: null,
            employerOrgId: null,
            employerOrgName: null,
            endDate: null,
            isCurrent: true,
            jobArea: null,
            orgIcon: null,
            orgName: null,
            startDate: null,
            titles: [],
        }];
    }

    initEmploymentJob(employment) {
        employment.employmentCompanyFilter = angular.copy(this.staticData[2]);
        if (employment.employerOrgId || employment.employerOrgName) {
            employment.employmentCompanyFilter.selected = [{
                uid: employment.employerOrgId || 0,
                value: employment.employerOrgName || '',
                required: 'optional',
            }];
        }
        employment.employmentTitlesFilter = angular.copy(this.staticData[3]);
        employment.employmentTitlesFilter.selected = _.map(employment.titles, value => ({
            uid: value.titleId,
            value: value.title,
            required: 'optional',
        }));
        if (employment.startDate) {
            let date = new Date(employment.startDate);
            employment.startMonth = date.getMonth();
            employment.startYear = date.getFullYear();
        }

        if (employment.endDate) {
            let date = new Date(employment.endDate);
            employment.endMonth = date.getMonth();
            employment.endYear = date.getFullYear();
        }
    }

    @Async()
    async getLocationLangLat(location) {
        const deferred = this.$q.defer();
        const response = this.locationService.getLognitudeLatitude(location.country, location.city, '');

        if (response.data && response.data.results && response.data.results.length > 0) {
            location.latitude = response.data.results[0].geometry.location.lat;
            location.longitude = response.data.results[0].geometry.location.lng;

            return deferred.resolve(location);
        }

        if (response.data.status === 'ZERO_RESULTS') {
            const response2 = await this.locationService.getLognitudeLatitude(location.country, '', '');

            if (response2.data && response2.data.results && response2.data.results.length > 0) {
                location.latitude = response2.data.results[0].geometry.location.lat;
                location.longitude = response2.data.results[0].geometry.location.lng;
                deferred.resolve(location);
            }
            deferred.resolve(null);
        }
    }

    initLanguage(language) {
        language.languageFilter = angular.copy({
            title: '',
            field: 'languages',
            lookupData: 'languages',
            type: 'static',
            dropDownText: 'ENTER_A_LANGUAGE',
            subCriteria: null,
            multiple: false,
            selected: [],
            showMultipleInput: true,
            setAsMandatory: false,
        });
    }

    initAddLanguage() {
        return [{
            languageCode: null,
            languageCodeId: null,
            proficiency: null,
        }];
    }

    deleteLanguage(languages, idx) {
        languages.splice(idx, 1);
    }

    initFormResidencyCandidateApproval() {
        this.applicanDetails = this.copyApproveCandidate();
        // copy the residency from tempResidencyProfile the init data
        this.tempResidencyProfile = angular.copy(this.applicanDetails.residency);
    }

    checkIfFieldResidencyCandidateApprovalChange() {
        if (!angular.equals(this.applicanDetails.residency, this.tempResidencyProfile)) { // if some field in the form changed we will call the update
            this.updateApproveCandidate(this.applicanDetails, this.talentForEmployer._id, 'showTalentResidency');
        }
    }

    initAddEducation() {
        return [{
            description: null,
            endDate: null,
            isCurrent: true,
            schoolName: null,
            startDate: null,
            degree: {
                major: null,
                majorId: null,
            },
        }];
    }

    initEducationHistory(education) {
        education.educationHistoryFilter = angular.copy(this.staticData[4]);
        if (education.schoolId || education.schoolName) {
            education.educationHistoryFilter.selected = [{
                uid: education.schoolId || 0,
                value: education.schoolName || '',
                required: 'optional',
            }];
        }
        education.educationDegreeFilter = angular.copy(this.staticData[5]);
        if (education.degree && (education.degree.majorId || education.degree.major)) {
            education.educationDegreeFilter.selected = [{
                uid: education.degree.majorId || 0,
                value: education.degree.major || '',
                required: 'optional',
            }];
        } else {
            education.educationDegreeFilter.selected = [];
        }

        if (education.startDate) {
            let date = new Date(education.startDate);
            education.startYear = date.getFullYear();
        }

        if (education.endDate) {
            let date = new Date(education.endDate);
            education.endYear = date.getFullYear();
        }
    }

    cleanMyJson(json) {
        for (let i = 0; i < json.educationHistory.length; i++) {
            delete json.educationHistory[i].educationDegreeFilter;
            delete json.educationHistory[i].educationHistoryFilter;
            delete json.educationHistory[i].monthsOfWork;
            if (json.educationHistory[i].degree && json.educationHistory[i].degree.constructor == Array) {
                if (json.educationHistory[i].degree.length == 0) {
                    json.educationHistory[i].degree = {};
                    return;
                }
                json.educationHistory[i].degree = {
                    major: json.educationHistory[i].degree[0].value,
                    majorId: json.educationHistory[i].degree[0].uid,
                };
            }
        }
    }

    async setupComponentData() {
        const { workflowId } = this.$stateParams;
        const [
            { result: profile },
            { result: positionData },
            { result: { canApprove } },
            lookupLanguages,
            proficiency,
        ] = await Promise.all([
            this.candidateApprovalService.getCandidateApproveProfile(workflowId),
            this.candidateApprovalService.getPosition(workflowId),
            this.candidateApprovalService.getResumeApprovalRequest(workflowId),
            this.staticDataService.getStaticData('languages'),
            this.staticDataService.getStaticData('languagesLevel'),
        ]);

        this.talentForEmployer = profile;
        this.positionData = positionData;
        this.canApprove = canApprove;
        this.lookupLanguages = lookupLanguages;
        this.proficiency = proficiency;
        this.residency = this.commonCodeService.getLocationString(this.talentForEmployer.residency);
        this.positionData.position.locationString = this.commonCodeService.getLocationString(this.positionData.position.location);
    }
}

export const CandidateApprovalComponentConfiguration = {
    template,
    controller: CandidateApprovalComponent,
    controllerAs: 'candidateApprovalCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateApprovalComponent', CandidateApprovalComponentConfiguration);

